import axios from 'axios';
import {EventBus} from "@/utilities/event-bus";
import {getAuthenticationToken, setAuthenticationToken} from "@/functions/authentication-functions";

export function onRequestsStarted(callback: () => void): void {

    EventBus.$on('request-start', () => callback());
}

export function emitRequestStarted(): void {

    EventBus.$emit('request-start');
}

export function onRequestsEnded(callback: () => void): void {

    EventBus.$on('request-end', () => callback());
}

export function emitRequestsEnded(): void {

    EventBus.$emit('request-end');
}

export function onForceLoggedOut(callback: () => void): void {

    EventBus.$on('force-logout', () => callback());
}

export function emitForceLogOut(): void {

    EventBus.$emit('force-logout');
}

export function onPaymentRequiredBlock(callback: () => void): void {

    EventBus.$on('block-payment-required', () => callback());
}

export function emitPaymentRequiredBlocked(): void {

    EventBus.$emit('block-payment-required');
}

export class PaymentRequiredError extends Error {}

export const HiddenAxios = axios.create({
    headers: {
        hidden: true,
    }
});

let numberOfAjaxCallPending = 0;

[axios.interceptors.request, HiddenAxios.interceptors.request]
.forEach(ax => ax.use(request => {
    const token = getAuthenticationToken();

    if(request.url && token) {

        request.headers.Authorization = `Bearer ${token}`;
    }

    const hidden = request.headers.hidden === true;

    if(hidden) {

        (request as Record<string, unknown>).hidden = hidden;
    }

    if (!hidden){

        if (numberOfAjaxCallPending == 0) {

            emitRequestStarted();
        }

        numberOfAjaxCallPending++;
    }

    return request;

}, error => Promise.reject(error)));

let loggedOut = false;

[axios.interceptors.response, HiddenAxios.interceptors.response]
.forEach(ax => ax.use(response => {

    const token = response.headers['x-update-token'];

    if (token)
    {
        setAuthenticationToken(token);
    }

    const hidden = (response.config as Record<string, unknown>).hidden === true;

    if (!hidden){

        numberOfAjaxCallPending--;

        if (numberOfAjaxCallPending == 0) {

            emitRequestsEnded();
        }
    }

    return response;

}, error => {

    const hidden = (error.config as Record<string, unknown>)?.hidden === true;

    if(!hidden) {

        numberOfAjaxCallPending--;

        if (numberOfAjaxCallPending == 0) {

            emitRequestsEnded();
        }
    }

    if (402 === error?.response?.status) {

        setTimeout(() => emitPaymentRequiredBlocked(), 10);

        return Promise.reject(new PaymentRequiredError('Payment Required'));
    }

    if (401 === error?.response?.status && !loggedOut) {

        loggedOut = true;

        setTimeout(() => {

            emitForceLogOut();

            loggedOut = false;
            
        }, 1000);
    }

    return Promise.reject(error);
}));
